import React, {useEffect, useState} from 'react'
import Ajax from '../../../../../helpers/Ajax'
import TableLoader from '../../../../UI/Dashboard/TableLoader';
import DataView from '../../../../UI/Dashboard/DataView';
import TableContainer from '../../../../UI/Dashboard/TableContainer';
import { Helmet } from 'react-helmet-async';
import ContentLayout from '../../../../Common/ContentLayout';
import EditButton from '../../../../UI/Dashboard/EditButton';
import DeleteButton from '../../../../UI/Dashboard/DeleteButton';

export default function ValueAddedList() {
    const [listData, setListData] = useState(null)
    useEffect(()=>{
    const getResponse = setTimeout(function(){  
        (async()=>{ 
        const response = await Ajax({
            url: `/home/services`,
            token: true,
        })
        if(response.data.status === "SUCCESS!"){
            setListData(response.data.result)
        }
        })()
    },100) 
    return()=>{
        clearInterval(getResponse)
    }
    },[])

    return (
    <ContentLayout title='Value Added' addNew='/admin/home/value-added/add-new'>
        <div className="row">
        <Helmet>
            <title>Value Added</title>
        </Helmet>
        <DataView title="Value Added List">
            <TableContainer>
                <thead>
                    <tr>
                        <td className="text-center">S.No</td>
                        <td className="text-start">Title</td>
                        <td className="text-start">Order</td>
                        <td className="text-start">Type</td>
                        <td className="text-center">Edit</td>
                        <td className="text-center">Delete</td>
                    </tr>
                </thead>
                <tbody>
                    {listData == null ? 
                    <TableLoader cols={6}/> : listData.length === 0 ? 
                    <tr>
                        <td colSpan={6} className="text-center">Data not available</td>
                    </tr> : listData.map((data, index)=>(
                    <tr key={data._id}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-start text-capitalize">{data.name}</td>
                        <td className="text-start">{data.sortOrder}</td>
                        <td className="text-start">{data.type}</td>
                        <td className="text-center">
                            <EditButton>{`/admin/home/value-added/${data._id}`}</EditButton>
                        </td>
                        <td className="text-center">
                            <DeleteButton url="/home/services" id={data._id} />
                        </td>
                    </tr>
                    ))}
                </tbody>
            </TableContainer>
        </DataView>
    </div>
    </ContentLayout>
    )
}
